import React from "react";
import { Container as MUIContainer, ContainerProps as MUIContainerProps } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface CustomContainerProps extends Omit<MUIContainerProps, "sx" | "maxWidth"> {
    children: React.ReactNode;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
    disableGutters?: boolean;
    fixed?: boolean;
    sx?: SxProps<Theme>;
    className?: string;
}

const Container: React.FC<CustomContainerProps> = ({
    children,
    maxWidth = "lg",
    disableGutters = false,
    fixed = false,
    sx,
    className = "",
    ...rest
}) => {
    return (
        <MUIContainer
            maxWidth={maxWidth}
            disableGutters={disableGutters}
            fixed={fixed}
            sx={sx}
            className={className}
            {...rest}
        >
            {children}
        </MUIContainer>
    );
};

export default Container;
